/*
 * @Description: 期初订单
 * @Author: 杨志航
 * @Date: 2026-09-20 09:20:07
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  DatePicker,
  message,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Import from '@/components/Import'
import Export from '@/components/Export'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const QcddOrder = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [projectList, setProjectList] = useState([])
  const [productList, setProductList] = useState([])
  const [visibleFile, setVisibleFile] = useState(false)
  const [showExport, setShowExport] = useState(false)
  const [portIdentifyList, setPortIdentifyList] = useState([])
  const [importType, setImportType] = useState(1) // 1.退单 2.提单
  const ImportRef = useRef(null)
  const productsRef = useRef(null)

  useEffect(() => {
    getSearchData()
    resetParams()
    getList()
  }, [])
  
  const getSearchData = () => {
    Promise.all([
      api.getPortIdentifyList({ limit: global.paramsLimit }),
      api.getsysProjectChilds({ pid: 0 })
    ]).then(data => {
      setPortIdentifyList(data[0].list)
      setProjectList(data[1])
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getQcddOrderList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.import_time && vals.import_time.length === 2) {
          vals.import_time_start = vals.import_time[0].format(dateFormat)
          vals.import_time_end = vals.import_time[1].format(dateFormat)
        }
        delete vals.import_time
        if (vals.effective_date && vals.effective_date.length === 2) {
          vals.effective_date_start = vals.effective_date[0].format(dateFormat)
          vals.effective_date_end = vals.effective_date[1].format(dateFormat)
        }
        delete vals.effective_date
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const onChangeProject = id => {
    if (id) {
      api.getsysProjectChilds({ pid: id }).then(data => {
        setProductList(data)
      })
    } else {
      setProductList([])
    }
    setFieldsValue({
      productId: undefined,
    })
  }

  const onImportFile = type => {
    setImportType(type)
    setVisibleFile(true)
    ImportRef.current.onRemoved()
  }

  const doImport = (fileList) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        api[importType === 1 ? 'importQcddOrderTuidan' : 'importQcddOrderTidan']({
          path: fileList[0].url
        }).then(() => {
          message.success('导入成功')
          ImportRef.current.onLoading()
          onReset()
          setVisibleFile(false)
        }).catch(() => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="订单编号">
            {getFieldDecorator('order_no')(<Input placeholder="请输入订单编号" />)}
          </FormItem>
          <FormItem label="厂商客户名称">
            {getFieldDecorator('vendor_customer_name')(<Input placeholder="请输入厂商客户名称" />)}
          </FormItem>
          <FormItem label="OA厂商ID">
            {getFieldDecorator('vendor')(<Input placeholder="请输入OA厂商ID" />)}
          </FormItem>
          <FormItem label="导入日期">
            {getFieldDecorator('import_time')(<RangePicker
              placeholder={['开始日期', '结束日期']}
            />)}
          </FormItem>
          <FormItem label="项目">
            {getFieldDecorator('project_id')(<Select
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={onChangeProject}
            >
              {
                projectList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="产品">
            {getFieldDecorator('product_id')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                productList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="供应商">
            {getFieldDecorator('supplier_name')(<Input placeholder="请输入供应商" />)}
          </FormItem>
          <FormItem label="生效日期">
            {getFieldDecorator('effective_date')(<RangePicker
              placeholder={['开始日期', '结束日期']}
            />)}
          </FormItem>
          <FormItem label="端口识别号">
            {getFieldDecorator('port_identify')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                portIdentifyList.map((item, index) => <Option key={index} value={item.portIdentify}>{item.portIdentify}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="原始厂商ID">
            {getFieldDecorator('original_vendor_id')(<Input placeholder="请输入原始厂商ID" />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={() => setShowExport(true)}>数据导出</Button>
        <Button type="primary" onClick={() => onImportFile(1)} style={{ marginLeft: 15 }}>期初订单退单导入</Button>
        <Button type="primary" onClick={() => onImportFile(2)} style={{ marginLeft: 15 }}>期初订单导入</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column title="订单编号" dataIndex="order_no" fixed="left" />
        <Column title="客户名称" dataIndex="customer_name" />
        <Column title="厂商客户名称" dataIndex="vendor_customer_name" />
        <Column title="厂商客户账号" dataIndex="vendor_customer_account" />
        <Column title="原始厂商ID" dataIndex="original_vendor_id" />
        <Column title="OA厂商ID" dataIndex="vendor" />     
        <Column title="项目" dataIndex="project_name" />
        <Column title="产品" dataIndex="product_name" />
        <Column title="端口识别号" dataIndex="port_identify" />
        <Column title="供应商" dataIndex="supplier_name" />
        <Column title="资金主体" dataIndex="fund_company_name" />
        <Column title="提单公司" dataIndex="company_name" />
        <Column title="生效时间" dataIndex="effective_date" />
        <Column title="市场价" dataIndex="market_price" />
        <Column title="可用消耗" dataIndex="available" />
        <Column title="订单负责人" dataIndex="staff_name" />
        <Column title="订单类型" dataIndex="order_type_name" />
        <Column title="订单生成方式" dataIndex="order_source_name" />
        <Column title="导入时间" dataIndex="import_time" />
      </Table>
    </div>
    <Import
      onSearch={doImport}
      visibleFile={visibleFile}
      onCloseImport={() => setVisibleFile(false)}
      ImportTemplate={`/api/File/DownTemplate?url=/templates/${importType === 1 ? '期初订单退单导入模板.xlsx&name=期初订单退单导入模板' : '期初订单提单导入模板.xlsx&name=期初订单提单导入模板'}`}
      ImportRef={ImportRef}
    />
    <Export
      show={showExport}
      onCancel={() => {
        setShowExport(false)
        productsRef.current.changeVal()
      }}
      tplUrl="getQcddOrderExportTpl"
      fieldsUrl="getQcddOrderTplItems"
      saveUrl="saveQcddOrderLevelTpl"
      exportUrl="exportQcddOrder"
      method="export"
      parame={{ ExportType: 'qcddorder.export', ...searchParams }}
      cRef={productsRef}
      disableDataRange={true}
    />
  </>
}

export default Form.create()(QcddOrder)
